import request from '@/utils/request'

const api = {
    getTreeNodeList: '/node/getTreeNodeList',
}
//获取功能节点集合
export function getTreeNodeList () {
  return request({
    url: api.getTreeNodeList,
    method: 'get'    
  })
}
